<template>
    <div class="homeHeader">
        <div class="homeHeaderTitle">
            {{ title }}
        </div>
        <div class="homeHeaderHandles">
            <div class="homeHeaderTeleportHandles">
                <slot></slot>
            </div>
            <userAvatarCard></userAvatarCard>
        </div>
    </div>
</template>

<script>
import userAvatarCard from '@/components/userAvatarCard.vue'
    export default {
        components: {
            userAvatarCard,
        },
        props: {
            title: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                isCollapse: false,
            }
        }
    }
</script>

<style lang="less">
.homeHeader {
    height: 78px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #dcdfe6;
    padding: 0 20px;
    flex-shrink: 0;
    .homeHeaderTitle {
        font-size: 16px;
        font-weight: 550;
        color: #38495c;
        line-height: 22px;
        cursor: pointer;
    }
    .homeHeaderHandles {
        display: flex;
        align-items: center;
        .homeHeaderTeleportHandles {
            display: flex;
            align-items: center;
            margin-right: 20px;
        }
    }
}
</style>